const LINE_HEIGHT_PX = 16;

export function wheelDeltaPixels(delta, deltaMode, pageSize) {
  if(!Number.isFinite(delta) || delta === 0) return 0;
  if(deltaMode === 1) return delta * LINE_HEIGHT_PX;
  if(deltaMode === 2) return delta * (Number.isFinite(pageSize) ? pageSize : 0);
  return delta;
}

/**
 * Apply an iframe/map wheel event to the parent page so scrolling continues
 * when ArcGIS has swallowed the native wheel.
 */
export function applyWheelScrollToWindow(targetWindow, eventLike = {}) {
  if(!targetWindow) return;

  const {deltaX = 0, deltaY = 0, deltaMode = 0, shiftKey = false} = eventLike;
  const pageW = targetWindow.innerWidth || 0;
  const pageH = targetWindow.innerHeight || 0;
  let x = wheelDeltaPixels(deltaX, deltaMode, pageW);
  let y = wheelDeltaPixels(deltaY, deltaMode, pageH);

  if(shiftKey && x === 0 && y !== 0){
    x = y;
    y = 0;
  }

  if(x === 0 && y === 0) return;

  const doc = targetWindow.document;
  const scroller = doc && (doc.scrollingElement || doc.documentElement);
  if(scroller && typeof scroller.scrollBy === 'function'){
    scroller.scrollBy(x, y);
    return;
  }
  if(typeof targetWindow.scrollBy === 'function'){
    targetWindow.scrollBy(x, y);
  }
}
